import { ACTIONS } from '../actions';

/**
 * Initial state for tabs
 * {
 *  name: '',
 *  title: '',
 *  component
 * }
 * @type {Array}
 */
const INITIAL_STATE = []

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.REGISTER_TAB:
            if(!state.find(t => action.payload.name === t.name)) {
              state.push(action.payload);
            }
          return state;
        default:
            return state;
    }
}
